import { render, staticRenderFns } from "./bgxqCom.vue?vue&type=template&id=3e69d6e4&scoped=true&"
import script from "./bgxqCom.vue?vue&type=script&lang=js&"
export * from "./bgxqCom.vue?vue&type=script&lang=js&"
import style0 from "./bgxqCom.vue?vue&type=style&index=0&id=3e69d6e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e69d6e4",
  null
  
)

export default component.exports